import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer, MDBCard, MDBCardBody, MDBBtn, MDBIcon,
  MDBRow, MDBCol, MDBTable, MDBTableBody, MDBTableHead
} from "mdbreact";
import API_URL from '../config';
import axios from 'axios';

class AdminGestionUsuarios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarios: [],
      cargando: false,
      volverDashboard: false,
      // Nuevo usuario
      nuevoLogin: '',
      nuevoNombre: '',
      nuevoPass: '',
      nuevoCargo: 'WEB-OPERADOR',
      // Modales
      modalExito: '',
      modalError: '',
      modalConfirmar: null,
      modalPassTemporal: null
    };
  }

  getToken = function() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  }

  componentDidMount() {
    this.cargarUsuarios();
  }

  cargarUsuarios = function() {
    var token = this.getToken();
    this.setState({ cargando: true });
    axios.post(API_URL + '/admin/listarusuarios/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ autorizacion: token })
    })
    .then(function(response) {
      this.setState({ usuarios: response.data || [], cargando: false });
    }.bind(this))
    .catch(function(err) { console.error(err); this.setState({ cargando: false }); }.bind(this));
  }

  crearUsuario = function() {
    if (!this.state.nuevoLogin.trim() || !this.state.nuevoNombre.trim() || !this.state.nuevoPass.trim()) {
      this.setState({ modalError: 'Complete todos los campos' });
      return;
    }
    var token = this.getToken();
    axios.post(API_URL + '/admin/crearusuario/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({
        login: this.state.nuevoLogin.trim(),
        nombre: this.state.nuevoNombre.trim(),
        pass: this.state.nuevoPass,
        cargo: this.state.nuevoCargo,
        autorizacion: token
      })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0 && response.data[0].resultado === 'OK') {
        this.setState({ modalExito: 'Usuario creado correctamente', nuevoLogin: '', nuevoNombre: '', nuevoPass: '', nuevoCargo: 'WEB-OPERADOR' });
        this.cargarUsuarios();
      } else {
        var msg = response.data && response.data[0] ? response.data[0].mensaje : 'Error al crear usuario';
        this.setState({ modalError: msg });
      }
    }.bind(this))
    .catch(function(err) { console.error(err); this.setState({ modalError: 'Error de conexión' }); }.bind(this));
  }

  toggleEstado = function(login, estadoActual) {
    var token = this.getToken();
    var nuevoEstado = estadoActual ? 4 : 1;
    axios.post(API_URL + '/admin/toggleusuario/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ login: login, estado: nuevoEstado, autorizacion: token })
    })
    .then(function() {
      this.setState({ modalExito: estadoActual ? 'Usuario deshabilitado' : 'Usuario habilitado', modalConfirmar: null });
      this.cargarUsuarios();
    }.bind(this))
    .catch(function(err) { console.error(err); });
  }

  generarPassTemporal = function() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var pass = '';
    for (var i = 0; i < 6; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pass;
  }

  resetPass = function(login) {
    var token = this.getToken();
    var passTemporal = this.generarPassTemporal();
    axios.post(API_URL + '/admin/resetpassusuario/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ login: login, pass_temporal: passTemporal, autorizacion: token })
    })
    .then(function(response) {
      if (response.data && response.data[0]) {
        this.setState({ modalPassTemporal: { login: login, pass: passTemporal } });
      }
    }.bind(this))
    .catch(function(err) { console.error(err); });
  }

  render() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    if (!datos || !datos[0]) return <Redirect to="/" />;
    if (this.state.volverDashboard) return <Redirect push={false} to={{ pathname: "/admin-dashboard", state: { datos: datos } }} />;

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>
        <MDBContainer className="pt-4 pb-3">
          <MDBBtn onClick={function() { this.setState({ volverDashboard: true }); }.bind(this)}
            style={{ borderRadius: '8px', margin: '0 0 16px 0', fontWeight: '500', fontSize: '0.85rem', padding: '8px 20px', background: '#7A1622', border: 'none', color: '#fff' }}>
            <MDBIcon icon="arrow-left" className="mr-2" />Volver al Panel
          </MDBBtn>

          {/* Crear usuario */}
          <MDBCard style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(46,125,50,0.12)', overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg, #2E7D32, #43A047)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MDBIcon icon="user-plus" style={{ color: '#fff', fontSize: '1.1rem' }} />
              <span style={{ color: '#fff', fontWeight: '600', fontSize: '0.95rem' }}>Crear Nuevo Usuario</span>
            </div>
            <MDBCardBody style={{ padding: '20px 24px' }}>
              <MDBRow className="align-items-end">
                <MDBCol md="2" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Login</label>
                  <input type="text" className="form-control" placeholder="Ej: operador02"
                    value={this.state.nuevoLogin} onChange={function(e) { this.setState({ nuevoLogin: e.target.value }); }.bind(this)} />
                </MDBCol>
                <MDBCol md="3" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Nombre</label>
                  <input type="text" className="form-control" placeholder="Nombre completo"
                    value={this.state.nuevoNombre} onChange={function(e) { this.setState({ nuevoNombre: e.target.value }); }.bind(this)} />
                </MDBCol>
                <MDBCol md="2" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Contraseña</label>
                  <input type="text" className="form-control" placeholder="Contraseña"
                    value={this.state.nuevoPass} onChange={function(e) { this.setState({ nuevoPass: e.target.value }); }.bind(this)} />
                </MDBCol>
                <MDBCol md="2" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Cargo</label>
                  <select className="browser-default custom-select" value={this.state.nuevoCargo}
                    onChange={function(e) { this.setState({ nuevoCargo: e.target.value }); }.bind(this)}>
                    <option value="WEB-OPERADOR">Operador</option>
                    <option value="WEB-ADMINISTRADOR">Administrador</option>
                  </select>
                </MDBCol>
                <MDBCol md="2" className="mb-2">
                  <MDBBtn onClick={this.crearUsuario.bind(this)}
                    style={{ borderRadius: '8px', margin: 0, fontWeight: '600', fontSize: '0.85rem', padding: '10px 20px', background: '#2E7D32', border: 'none', color: '#fff', width: '100%' }}>
                    <MDBIcon icon="plus" className="mr-1" />Crear
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>

          {/* Lista de usuarios */}
          <MDBCard className="mt-3" style={{ borderRadius: '10px' }}>
            <MDBCardBody>
              <h6 style={{ color: '#2E7D32', fontWeight: '600', marginBottom: '12px' }}>
                <MDBIcon icon="users" className="mr-2" />Usuarios del Sistema
              </h6>
              {this.state.cargando ? (
                <div className="text-center py-4"><MDBIcon icon="spinner" spin size="2x" style={{ color: '#2E7D32' }} /></div>
              ) : this.state.usuarios.length > 0 ? (
                <MDBTable striped small responsive style={{ fontSize: '0.85rem' }}>
                  <MDBTableHead>
                    <tr>
                      <th>Login</th>
                      <th>Nombre</th>
                      <th>Roles</th>
                      <th>Estado</th>
                      <th>Último acceso</th>
                      <th>Acciones</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {this.state.usuarios.map(function(u) {
                      var esActivo = u.estado_Usuario === 1;
                      return (
                        <tr key={u.login}>
                          <td style={{ fontWeight: '600' }}>{u.login}</td>
                          <td>{u.nombre}</td>
                          {/* 11/08/2026 - antes mostraba el campo 'cargo' de
                              sec_Usuario, que solo tenia dos valores posibles.
                              Ahora llegan los roles reales de SGR_Web, que
                              pueden ser varios y se asignan en /admin/permisos
                              de Remuneraciones Web. */}
                          <td>
                            {(u.cargo || 'Sin rol').split(', ').map(function(nombreRol) {
                              var esAdminRol = nombreRol === 'Administrador';
                              return (
                                <span key={nombreRol} style={{
                                  padding: '2px 10px', borderRadius: '10px', fontSize: '0.78rem', fontWeight: '600',
                                  marginRight: '4px', display: 'inline-block',
                                  background: esAdminRol ? '#fce4ec' : '#e3f2fd',
                                  color: esAdminRol ? '#7A1622' : '#1565C0'
                                }}>
                                  {nombreRol}
                                </span>
                              );
                            })}
                          </td>
                          <td>
                            <span style={{
                              padding: '2px 10px', borderRadius: '10px', fontSize: '0.78rem', fontWeight: '600',
                              background: esActivo ? '#e8f5e9' : '#fdecea', color: esActivo ? '#2E7D32' : '#C62828'
                            }}>
                              {esActivo ? 'Activo' : 'Inactivo'}
                            </span>
                          </td>
                          <td style={{ fontSize: '0.8rem' }}>
                            {u.ultimo_acceso ? new Date(u.ultimo_acceso).toLocaleString('es-PE') : 'Nunca'}
                          </td>
                          <td>
                            <div style={{ display: 'flex', gap: '4px' }}>
                              <button type="button" onClick={function() { this.setState({ modalConfirmar: { login: u.login, estado: esActivo } }); }.bind(this)}
                                style={{ borderRadius: '6px', margin: 0, padding: '5px 12px', backgroundColor: esActivo ? '#ef5350' : '#2E7D32', border: 'none', color: '#fff', fontSize: '0.75rem', cursor: 'pointer', fontWeight: '600' }}>
                                <MDBIcon icon={esActivo ? 'user-slash' : 'user-check'} className="mr-1" />
                                {esActivo ? 'Deshabilitar' : 'Habilitar'}
                              </button>
                              <button type="button" onClick={function() { this.resetPass(u.login); }.bind(this)}
                                style={{ borderRadius: '6px', margin: 0, padding: '5px 12px', backgroundColor: '#1565C0', border: 'none', color: '#fff', fontSize: '0.75rem', cursor: 'pointer', fontWeight: '600' }}>
                                <MDBIcon icon="key" className="mr-1" />Reset Pass
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    }.bind(this))}
                  </MDBTableBody>
                </MDBTable>
              ) : (
                <div className="text-center py-4">
                  <MDBIcon icon="users" size="2x" style={{ color: '#ccc' }} />
                  <p style={{ color: '#999', marginTop: '8px' }}>No se encontraron usuarios</p>
                </div>
              )}
            </MDBCardBody>
          </MDBCard>
        </MDBContainer>

        {/* Modal Confirmar */}
        {this.state.modalConfirmar && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fff3e0', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="question-circle" style={{ color: '#F57C00', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#333', marginBottom: '20px' }}>
                ¿{this.state.modalConfirmar.estado ? 'Deshabilitar' : 'Habilitar'} al usuario <span style={{ color: '#7A1622' }}>{this.state.modalConfirmar.login}</span>?
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <MDBBtn onClick={function() { this.toggleEstado(this.state.modalConfirmar.login, this.state.modalConfirmar.estado); }.bind(this)}
                  style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 36px', background: '#7A1622', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="check" className="mr-2" />Sí
                </MDBBtn>
                <MDBBtn onClick={function() { this.setState({ modalConfirmar: null }); }.bind(this)}
                  style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 36px', background: '#666', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="times" className="mr-2" />No
                </MDBBtn>
              </div>
            </div>
          </div>
        )}

        {/* Modal Contraseña Temporal */}
        {this.state.modalPassTemporal && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '480px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fff3e0', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="key" style={{ color: '#F57C00', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#333', marginBottom: '6px' }}>Contraseña temporal generada</p>
              <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '16px' }}>
                Usuario: <strong style={{ color: '#1565C0' }}>{this.state.modalPassTemporal.login}</strong>
              </p>
              <div style={{ background: '#f5f5f5', border: '2px dashed #F57C00', borderRadius: '10px', padding: '16px', marginBottom: '16px' }}>
                <small style={{ color: '#888', fontSize: '0.8rem' }}>Contraseña temporal:</small>
                <div style={{ fontSize: '2rem', fontWeight: '800', letterSpacing: '6px', color: '#7A1622', fontFamily: 'monospace' }}>
                  {this.state.modalPassTemporal.pass}
                </div>
              </div>
              <p style={{ fontSize: '0.82rem', color: '#c0392b', marginBottom: '16px' }}>
                <MDBIcon icon="exclamation-circle" className="mr-1" />
                El usuario deberá cambiar esta contraseña al iniciar sesión
              </p>
              <button type="button" onClick={function() { this.setState({ modalPassTemporal: null }); }.bind(this)}
                style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', backgroundColor: '#2E7D32', border: 'none', color: '#fff', cursor: 'pointer' }}>
                <MDBIcon icon="check" className="mr-2" />Entendido
              </button>
            </div>
          </div>
        )}

        {/* Modal Éxito */}
        {this.state.modalExito && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#e8f5e9', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="check-circle" style={{ color: '#2E7D32', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2E7D32', marginBottom: '20px' }}>{this.state.modalExito}</p>
              <MDBBtn onClick={function() { this.setState({ modalExito: '' }); }.bind(this)}
                style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', background: '#2E7D32', border: 'none', color: '#fff' }}>
                Aceptar
              </MDBBtn>
            </div>
          </div>
        )}

        {/* Modal Error */}
        {this.state.modalError && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fdecea', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="exclamation-triangle" style={{ color: '#c62828', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#c62828', marginBottom: '20px' }}>{this.state.modalError}</p>
              <MDBBtn onClick={function() { this.setState({ modalError: '' }); }.bind(this)}
                style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', background: '#7A1622', border: 'none', color: '#fff' }}>
                Cerrar
              </MDBBtn>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdminGestionUsuarios;
